import { CustomerRemoteInfo } from '@@types'
import { gql, useQuery } from '@apollo/client'

interface PingAuthData {
  pingAuth?: CustomerRemoteInfo
}

export const GQL_QUERY_PING_AUTH = gql`
  query PingAuth {
    pingAuth {
      id
      phone
      first_name
      last_name
      receipt_email
      status
      new_phone
      email
      new_email
      isEmailVerified
      secondsBeforeDeletion
      requireRegistration
    }
  }
`

export const usePingAuth = () => {
  const { data, loading, error, refetch } = useQuery<PingAuthData>(GQL_QUERY_PING_AUTH)

  return {
    data: data?.pingAuth,
    loading,
    error,
    refetch,
  }
}
